import cloneDeep from 'lodash/cloneDeep';

export function isEmpty(obj) {
    if (obj === null || obj === undefined) return true;

    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    if (typeof obj === 'number' && !Number.isNaN(obj)) return false;

    if (typeof obj !== 'object') return true;

    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function isFormField(formField) {
    if (formField == null) return false;

    if (!formField.fieldKey) {
        return false;
    }

    if (typeof formField.fieldType === 'number' && Number.isNaN(formField.fieldType)) return false;

    return true;
}

export function deepCopyObject(obj) {
    return cloneDeep(obj);
}

export function isAllWhiteSpace(myString) {
    return !(/\S/.test(myString));
}
